module.exports = __webpack_public_path__ + "static/media/005.810a1f15.jpg";